import axios, { type AxiosError, type AxiosInstance, type AxiosRequestConfig, type AxiosResponse } from "axios";
import router from "@/router";
import type { UserInfo } from "@/types/UserModel";
import { ServiceResponse } from "@/types/RequestResponseModels";
import { useUserStore } from "@/stores/user";
import { useErrorStore } from "@/stores/error";
import { useCommonStore } from "@/stores/common";
import { buildPlatformLogoutUrl, resolveApiBaseUrl, resolvePlatformUrl } from "@/utils/tenant";

//todo: çalışırken loading çıkması
//todo: extractErrorText metodunu adam et. httpbase'e bir param ekle. error'u direk versin mi bize mi bıraksın
//todo: 401 ise logout

export abstract class HTTPBaseService {
  protected instance: AxiosInstance;
  protected token: string | undefined = "";
  protected readonly baseURL: string;
  protected userStore = useUserStore();
  protected errorStore = useErrorStore();
  protected commonStore = useCommonStore();

  public constructor(baseURL: string) {
    const resolvedBaseUrl = resolveApiBaseUrl(baseURL);
    this.baseURL = resolvedBaseUrl;
    this.instance = axios.create({
      baseURL: resolvedBaseUrl,
    });

    const user = this.userStore.getUser;
    this.token = user?.Token;

    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
  }

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest);
  };

  private initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use((response) => {
      this.handleDates(response.data);
      this.commonStore.decreaseLoading();

      return response;
    }, this.handleError);
  };

  isoDateFormat = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;

  private isIsoDateString(value: any): boolean {
    const isDate = value && typeof value === "string" && this.isoDateFormat.test(value);
    return isDate;
  }

  private handleDates = (body: any) => {
    if (body === null || body === undefined || typeof body !== "object") return body;

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (this.isIsoDateString(value)) body[key] = new Date(value);
      else if (typeof value === "object") this.handleDates(value);
    }
  };

  private handleRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
    if (config.headers && this.token) config.headers["Authorization"] = `Bearer ${this.token}`;
    this.commonStore.increaseLoading();
    return config;
  };

  loggedOut = false;

  private handleError = async (error: AxiosError) => {
    this.commonStore.decreaseLoading();

    if (error.response) {
      if (error.response.status && error.response.status == 401 && !this.loggedOut) {
        this.loggedOut = true;
        this.errorStore.setError({
          ErrorType: 'Error',
          ErrorText: 'Giriş Yapınız'
        });
        this.doSignOut();
        return;
      }
    }

    const errors: string[] = [];

    if (error.response) {
      if (error.response.statusText) errors.push(error.response.statusText);
      if (error.response.data) {
        if(error.response.data instanceof ServiceResponse){
          return Promise.reject(error.response.data);          
        }
        errors.push(JSON.stringify(error.response.data));
      }
    } else if (error.message) errors.push(error.message);

    if (errors.length == 0) {
      if(error.response)
        if(error.response.status && error.response.status == 403){
          errors.push("Yetkiniz bulunmamaktadır!");
      }else
        errors.push("beklenmeyen bir hata oluştu");
    }

    const errorResponse = new ServiceResponse<AxiosError>(error);
    errorResponse.Message = errors.join(" - ");

    return Promise.reject(errorResponse);
  };

  // public extractErrorText(error: AxiosResponse<any>): ServiceResponse<AxiosResponse<any>> {
  //   const errors: string[] = [];
  //   if (error) {
  //     if (error.statusText) errors.push(error.statusText);
  //     if (error.data) errors.push(JSON.stringify(error.data));
  //   }

  //   const errStr = errors.join("\r\n");

  //   const errorResponse = new ServiceResponse<AxiosResponse<any>>(error);
  //   errorResponse.IsSuccess = false;
  //   errorResponse.Message = errStr;

  //   return errorResponse;
  // }

  public doSignOut(): void {
    this.userStore.setUser(null);
    if (typeof window !== "undefined") {
      window.location.href = buildPlatformLogoutUrl(resolvePlatformUrl("https://portal.finmony.com"));
      return;
    }
    router.push({ path: "/" });
  }
}
